<app-generic-container *ngIf="outlet.isActivated == false">
  <div class="buttonMenuContainer">
    <ng-container *ngFor="let menuItem of menuChildItems">

    <ng-container *ngxPermissionsOnly="menuItem.roles">
        <div class="mt-2">{{ menuItem.title }}</div>
        <ul
          class="nav nav-pills-a3factura nav-pills-a3factura-primary nav-pills-a3factura-icons mt-1"
          role="tablist"
        >
          <ng-container *ngFor="let menuItemChild of menuItem.childs">
            <li class="nav-item" *ngxPermissionsOnly="menuItemChild.roles">
              <app-button-menu-item
                *ngIf="menuItemChild.sortTitle !== 'CAL'"
                [icon]="menuItemChild.icon"
                [title]="menuItemChild.title"
                [path]="menuItem.path + '/' + menuItemChild.path"
                [newButton]="menuItemChild.allowNew"
              ></app-button-menu-item>

              <app-button-menu-item-popup
                *ngIf="menuItemChild.sortTitle === 'CAL'"
                [icon]="menuItemChild.icon"
                [title]="menuItemChild.title"
                [path]="menuItem.path + '/' + menuItemChild.path"
                [newButton]="menuItemChild.allowNew"
                [sortTitle]="menuItemChild.sortTitle"
              ></app-button-menu-item-popup>
            </li>
          </ng-container>
        </ul>
      </ng-container>
    </ng-container>
  </div>
</app-generic-container>

<router-outlet #outlet="outlet"></router-outlet>
